<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <ManagerSidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getManagerUserProfile" />

      <ManagerCandidatesList />
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import ManagerSidebar from '@/components/Navigations/ManagerSidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import ManagerCandidatesList from '@/components/Manager/Candidates/ManagerCandidatesList';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    ManagerSidebar,
    TopNavbar,
    ManagerCandidatesList,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    isToggled: false,
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerProfile', 'retrieveManagerUserProfile']),
  },
  computed: { ...mapGetters('managerStoreModule', ['getManagerProfile', 'getManagerUserProfile']) },
  mounted() {
    this.retrieveManagerProfile();
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';

/* #activities,
#emails {
  h6 {
    font-size: 18px;
    font-family: $font-family-sans-serif;
  }

  .activities-media li {
    border-radius: 0 !important;
    border: 0;
    padding-right: 70px;
  }

  .activities-media li:nth-child(odd) {
    border-left: 5px solid #f05a00;
    background-color: #f1f1f3;
  }

  .activities-media li:nth-child(even) {
    border-left: 5px solid #747674;
  }

  .activities-name {
    font-family: Lato;
    color: $color-base-blue;
    letter-spacing: 0.9px;
    margin: 0;
  }

  .activities-status-color {
    color: #f05a00;
  }
} */
</style>
